import { AppPermissions } from '../models/user-permission-model';

export const ROLE_PERMISSIONS_MAP: Record<string, Partial<AppPermissions>> = {
  globalAdmin: {
    user: { view: true, create: true, edit: true, delete: true },
    store: { view: true, create: true, edit: true, delete: true },
    company: { view: true, create: true, edit: true, delete: true },
    storeGroup: { view: true, create: true, edit: true, delete: true },
    ap: { view: true, create: false, edit: false, delete: false },
    asset: { view: true, create: true, edit: true, delete: true },
    expense: { view: true, create: false, edit: false, delete: false },
    RM: { view: true, create: false, edit: false, delete: false },
    approvalProcess: { view: true, create: true, edit: true, delete: true },
    vendors: { view: true, create: true, edit: true, delete: true },
  },

  companyAdmin: {
    user: { view: true, create: true, edit: true, delete: true },
    store: { view: true, create: true, edit: true, delete: true },
    company: { view: true, create: false, edit: false, delete: false },
    storeGroup: { view: true, create: true, edit: true, delete: true },
    ap: { view: true, create: true, edit: true, delete: false },
    asset: { view: true, create: true, edit: true, delete: true },
    expense: { view: true, create: false, edit: false, delete: false },
    RM: { view: true, create: false, edit: false, delete: false },
    approvalProcess: { view: true, create: true, edit: true, delete: true },
    vendors: { view: true, create: true, edit: true, delete: true },
  },

  srDirectorOperations: {
    user: { view: true, create: false, edit: false, delete: false },
    store: { view: true, create: false, edit: false, delete: false },
    company: { view: true, create: false, edit: false, delete: false },
    storeGroup: { view: true, create: false, edit: false, delete: false },
    ap: { view: true, create: false, edit: false, delete: false },
    asset: { view: true, create: true, edit: true, delete: true },
    expense: { view: true, create: true, edit: true, delete: true },
    RM: { view: true, create: true, edit: true, delete: true },
    approvalProcess: { view: true, create: true, edit: true, delete: true },
    vendors: { view: true, create: true, edit: false, delete: false },
  },

  directorOperations: {
    user: { view: true, create: false, edit: false, delete: false },
    store: { view: true, create: false, edit: false, delete: false },
    company: { view: true, create: false, edit: false, delete: false },
    storeGroup: { view: true, create: false, edit: false, delete: false },
    ap: { view: true, create: true, edit: true, delete: true },
    asset: { view: true, create: true, edit: true, delete: true },
    expense: { view: true, create: true, edit: true, delete: true },
    RM: { view: true, create: true, edit: true, delete: true },
    approvalProcess: { view: true, create: true, edit: true, delete: true },
    vendors: { view: true, create: true, edit: false, delete: false },
  },

  supervisor: {
    user: { view: true, create: false, edit: false, delete: false },
    store: { view: true, create: false, edit: false, delete: false },
    company: { view: true, create: false, edit: false, delete: false },
    storeGroup: { view: true, create: false, edit: false, delete: false },
    ap: { view: true, create: true, edit: true, delete: true },
    asset: { view: true, create: true, edit: true, delete: true },
    expense: { view: true, create: true, edit: true, delete: true },
    RM: { view: true, create: true, edit: true, delete: true },
    approvalProcess: { view: true, create: true, edit: true, delete: true },
    vendors: { view: true, create: false, edit: false, delete: false },
  },

  generalManager: {
    user: { view: true, create: false, edit: false, delete: false },
    store: { view: true, create: false, edit: false, delete: false },
    company: { view: true, create: false, edit: false, delete: false },
    storeGroup: { view: true, create: false, edit: false, delete: false },
    ap: { view: true, create: false, edit: false, delete: false },
    asset: { view: true, create: true, edit: true, delete: true },
    expense: { view: true, create: true, edit: true, delete: true },
    RM: { view: true, create: true, edit: true, delete: true },
    approvalProcess: { view: true, create: true, edit: true, delete: true },
    vendors: { view: true, create: false, edit: false, delete: false },
  },

  vpOperations: {
    user: { view: true, create: false, edit: false, delete: false },
    store: { view: true, create: false, edit: false, delete: false },
    company: { view: true, create: false, edit: false, delete: false },
    storeGroup: { view: true, create: false, edit: false, delete: false },
    ap: { view: true, create: false, edit: false, delete: false },
    asset: { view: true, create: true, edit: true, delete: true },
    expense: { view: true, create: true, edit: true, delete: true },
    RM: { view: true, create: true, edit: true, delete: true },
    approvalProcess: { view: true, create: true, edit: true, delete: true },
    vendors: { view: true, create: true, edit: true, delete: false },
  },

  employee: {
    expense: { view: true, create: true, edit: true, delete: true },
    RM: { view: true, create: true, edit: true, delete: true },
    asset: { view: true, create: false, edit: false, delete: false },
  },

  vendor: {
    vendors: { view: true, create: false, edit: false, delete: false },
    RM: { view: true, create: false, edit: false, delete: false },
    expense: { view: true, create: false, edit: false, delete: false },
  },

  accountsPayableManager1: {
    ap: { view: true, create: false, edit: true, delete: false },
    vendors: { view: true, create: true, edit: true, delete: false },
  },

  accountsPayableManager2: {
    ap: { view: true, create: false, edit: true, delete: false },
    vendors: { view: true, create: true, edit: true, delete: false },
  },

  accountsPayableCreator: {
    ap: { view: true, create: true, edit: true, delete: true },
    vendors: { view: true, create: true, edit: true, delete: false },
  },

  auditor1: {
    expense: { view: true, create: true, edit: true, delete: true },
  },

  auditor2: {
    expense: { view: true, create: true, edit: true, delete: true },
  },

  expenseInitiator: {
    expense: { view: true, create: true, edit: true, delete: true },
  },

  RMmanager: {
    RM: { view: true, create: true, edit: true, delete: true },
    vendors: { view: true, create: true, edit: true, delete: true },
    asset: { view: true, create: true, edit: true, delete: true },
  },
};
